import React, { useState, useEffect, forwardRef } from "react";
import { MonoButton } from "../kits";
import RoughBorder from "../kits/LayoutKit/RoughBorder";

// Wichtig: Die Komponente wird als "CookieModal" benannt
const CookieModal = forwardRef(({ initialConsent, onClose }, ref) => {
  // initialConsent wird vom Parent übergeben. Wenn nicht vorhanden, lade aus localStorage
  const [consent, setConsent] = useState(
    initialConsent || (() => {
      const stored = localStorage.getItem("cookieConsentV2");
      return stored ? JSON.parse(stored) : {
        essential: true, // Immer true, nicht deaktivierbar
        statistics: false,
        media: false,
      };
    })
  );

  const handleToggle = (key) => {
    setConsent((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const saveConsent = () => {
    localStorage.setItem("cookieConsentV2", JSON.stringify(consent));
    if (onClose) {
      onClose();
    }
  };

  useEffect(() => {
    if (initialConsent) {
      setConsent(initialConsent);
    }
  }, [initialConsent]);

  return (
    <div
      className="fixed inset-0 bg-gray-50 backdrop-blur-sm flex items-center justify-center z-[100]"
      onClick={(e) => {
        if (ref && ref.current && !ref.current.contains(e.target)) {
          saveConsent();
        }
      }}
    >
      <div
        ref={ref}
        className="relative w-[95%] max-w-lg bg-white shadow-2xl rounded-xl p-6 z-50 text-sm font-mono text-gray-800"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-mono font-semibold mb-2">Cookies & Drittanbieter</h2>
        <p className="text-xs text-gray-600 mb-4">
          Cookies, um Funktionen bereitzustellen und dein Nutzungserlebnis zu verbessern. Du kannst selbst entscheiden, welche Kategorien du erlaubst. Mehr dazu in unserer{" "}
          <a href="/datenschutz" className="underline text-black hover:text-orange-50 hover:bg-gray-900" target="_blank" rel="noopener noreferrer">
            Datenschutzerklärung
          </a>.
        </p>

        <div className="space-y-3 text-xs">
          {/* Essentielle Cookies */}
          <div className="flex justify-between items-center border-b py-2">
            <span>Essentiell (immer aktiv)</span>
            <span className="text-gray-500 italic">aktiv</span>
          </div>

          {/* Statistik */}
          <div className="flex justify-between items-center border-b py-2">
            <span>Statistik (Matomo)</span>
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={consent.statistics}
                onChange={() => handleToggle("statistics")}
                className="sr-only"
              />
              <div className="w-9 h-5 bg-gray-300 rounded-full relative transition">
                <div
                  className={`w-4 h-4 bg-white rounded-full shadow-md absolute top-0.5 left-0.5 transition-transform ${
                    consent.statistics ? "translate-x-4 bg-green-500" : ""
                  }`}
                />
              </div>
            </label>
          </div>

          {/* Medien */}
          <div className="flex justify-between items-center py-2">
            <span>Externe Medien (YouTube, GitHub, Instgram)</span>
            <label className="inline-flex items-center cursor-pointer">
              <input
                type="checkbox"
                checked={consent.media}
                onChange={() => handleToggle("media")}
                className="sr-only"
              />
              <div className="w-9 h-5 bg-gray-300 rounded-full relative transition">
                <div
                  className={`w-4 h-4 bg-white rounded-full shadow-md absolute top-0.5 left-0.5 transition-transform ${
                    consent.media ? "translate-x-4 bg-green-500" : ""
                  }`}
                />
              </div>
            </label>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <MonoButton
            onClick={saveConsent}
            className="px-4 py-2 text-xs w-full"
          >
            Einstellungen speichern
          </MonoButton>
        </div>

        {/* RoughBorder GANZ AUSSEN */}
        <RoughBorder
          parentRef={ref}
          radius={12}
          padding={2}
        color="#AC8E66" 
          strokeWidth={0.3}
          roughness={1}
          bowing={2}
        />
      </div>
    </div>
  );
});

export default CookieModal;
